        <div class="modal-header">
            <h4 class="modal-title">Historial de Revisiones Vehículo - {{element.patente}}</h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <kuv-lazy-table url={{url}} urlExcel={{excel}} [headers]="sesion.headers" [headersBlob]="sesion.headersBlob"
            [pageSize]="20" [reloadEmitter]="reloadEmitter" [filtros]="filtros" [columnas]="columnas" [acciones]="acciones"
            [useIndex]="true" [isRounded]="true" [hasShadow]="true"></kuv-lazy-table>
            <br>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cerrar</button>
        </div>